import React, { useState } from "react";
import axios from "axios";
import { Link,navigate, useNavigate } from "react-router-dom";

function Govt_id() {
  const [selectedFile, setSelectedFile] = useState(null);
  const [uploadStatus, setUploadStatus] = useState("");
  const navigate = useNavigate();
  const handleFileChange = (e) => {
    setSelectedFile(e.target.files[0]);
  };

  const handleUpload = async () => {
    if (!selectedFile) {
      setUploadStatus("No file selected.");
      return;
    }

    const formData = new FormData();
    formData.append("file", selectedFile);

    try {
      const response = await axios.post("/upload_govt_id", formData, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      });
      setUploadStatus("Upload successful!");
      console.log("Upload Response:", response.data);
    } catch (error) {
      setUploadStatus("Upload failed.");
      console.error("Upload Error:", error);
    }
  };

  const handleSkip = () => {
    navigate("/");
  };

  return (
    <div>
      <section className="register_section">
        <div className="container cont_registerpage">
          <div className="row">
            <div className="col-md-6 col-md-offset-3">
              <div className="row rowmain_registerpage">
                <div className="col-md-12 col6reisterdiv">
                  <div className="regidtermain_rightside">
                    <div className="register_logomain">
                      <a href="/">
                        <img src="images/logo_parqd_black.png" alt="Logo" />
                      </a>
                    </div>
                    <div className="reginner_heading">
                      <h2>Upload A Government Issued ID Proof</h2>
                      <p className="uploadgovt_text">
                        You need to upload a government ID proof like an Aadhar
                        card, voter ID card, etc.
                      </p>
                    </div>
                    <div className="regis_form_inner">
                      <form
                        className="regisformstart_maindiv"
                        onSubmit={(e) => e.preventDefault()}
                      >
                        <div className="main-wrapper maindivforuploadid_govt">
                          <div className="upload-main-wrapper">
                            <div className="upload-wrapper">
                              <input
                                type="file"
                                id="upload-file"
                                onChange={handleFileChange}
                              />
                              <svg
                                version="1.1"
                                xmlns="http://www.w3.org/2000/svg"
                                xmlnsXlink="http://www.w3.org/1999/xlink"
                                preserveAspectRatio="xMidYMid meet"
                                viewBox="224.3881704980842 176.8527621722847 221.13266283524905 178.8472378277154"
                                width="221.13"
                                height="178.85"
                              >
                                <defs>
                                  <path
                                    d="M357.38 176.85C386.18 176.85 409.53 204.24 409.53 238.02C409.53 239.29 409.5 240.56 409.42 241.81C430.23 246.95 445.52 264.16 445.52 284.59C445.52 284.59 445.52 284.59 445.52 284.59C445.52 309.08 423.56 328.94 396.47 328.94C384.17 328.94 285.74 328.94 273.44 328.94C246.35 328.94 224.39 309.08 224.39 284.59C224.39 284.59 224.39 284.59 224.39 284.59C224.39 263.24 241.08 245.41 263.31 241.2C265.3 218.05 281.96 199.98 302.22 199.98C306.67 199.98 310.94 200.85 314.93 202.46C324.4 186.96 339.88 176.85 357.38 176.85Z"
                                    id="b1aO7LLtdW"
                                  />
                                  <path
                                    d="M306.46 297.6L339.79 297.6L373.13 297.6L339.79 255.94L306.46 297.6Z"
                                    id="c4SXvvMdYD"
                                  />
                                  <path
                                    d="M350.79 293.05L328.79 293.05L328.79 355.7L350.79 355.7L350.79 293.05Z"
                                    id="b11si2zUk"
                                  />
                                </defs>
                                <g>
                                  <g>
                                    <g>
                                      <use
                                        xlinkHref="#b1aO7LLtdW"
                                        opacity={1}
                                        fill="#ffffff"
                                        fillOpacity={1}
                                      />
                                    </g>
                                    <g>
                                      <g>
                                        <use
                                          xlinkHref="#c4SXvvMdYD"
                                          opacity={1}
                                          fill="#363535"
                                          fillOpacity={1}
                                        />
                                      </g>
                                      <g>
                                        <use
                                          xlinkHref="#b11si2zUk"
                                          opacity={1}
                                          fill="#363535"
                                          fillOpacity={1}
                                        />
                                      </g>
                                    </g>
                                  </g>
                                </g>
                              </svg>
                              <span className="file-upload-text">
                                Upload File
                              </span>
                              {selectedFile && (
                                <div className="file-success-text">
                                  <svg
                                    version="1.1"
                                    id="check"
                                    xmlns="http://www.w3.org/2000/svg"
                                    xmlnsXlink="http://www.w3.org/1999/xlink"
                                    x="0px"
                                    y="0px"
                                    viewBox="0 0 100 100"
                                    xmlSpace="preserve"
                                  >
                                    <circle
                                      style={{
                                        fill: "rgba(0,0,0,0)",
                                        stroke: "#ffffff",
                                        strokeWidth: 10,
                                        strokeMiterlimit: 10,
                                      }}
                                      cx="49.799"
                                      cy="49.746"
                                      r="44.757"
                                    />
                                    <polyline
                                      style={{
                                        fill: "rgba(0,0,0,0)",
                                        stroke: "#ffffff",
                                        strokeWidth: 10,
                                        strokeLinecap: "round",
                                        strokeLinejoin: "round",
                                        strokeMiterlimit: 10,
                                      }}
                                      points="27.114,51 41.402,65.288 72.485,34.205"
                                    />
                                  </svg>{" "}
                                  <span>Successfully</span>
                                </div>
                              )}
                            </div>
                            <p id="file-upload-name">
                              {selectedFile
                                ? selectedFile.name
                                : "No file chosen"}
                            </p>
                          </div>
                        </div>
                        <div className="col-md-12 colforsignuopbtn maincolforupload_skip_govt">
                          <div className="col-md-12">
                            <div className="signupdivmaininner">
                              <button
                                type="button"
                                className="signupbtn_reg"
                                onClick={handleUpload}
                              >
                                Upload
                              </button>
                            </div>
                          </div>
                          <div className="col-md-12">
                            <div className="signupdivmaininner uploadgovtdiv">
                              <button
                                type="button"
                                className="signupbtn_reg skip_uploadbtn"
                                onClick={handleSkip}
                              >
                                Skip
                              </button>
                            </div>
                          </div>
                        </div>
                        {uploadStatus && (
                          <p className="upload-status">{uploadStatus}</p>
                        )}
                      </form>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}

export default Govt_id;
